import React from 'react';
import * as styles from './heading.module.css';
import { twMerge } from 'tailwind-merge'

const Heading = ({ children, variant = 'h1', className='', styleOverride = undefined }) => {
  return React.createElement(
    variant, // Tag type
    { className: `${className} ${styles[`${styleOverride || variant}Heading`]}` }, // Props
    children // Children
  );
};

export default Heading;